import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Servicepage from './pages/Servicepage';


import Aboutpage from './pages/Aboutpage';
import Termspage from './pages/Termspage';
import Privacypage from './pages/Privacypage';



// ScrollToTop
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/services" element={<Servicepage />} />
          <Route path="/terms" element={<Termspage />} />
            <Route path="/privacy" element={<Privacypage />} />
 
        <Route path="/about" element={<Aboutpage />} />


      </Routes>
    </>
  );
};

export default App;
